<template>
  <div class="campaign-page">
    <Header />
    <div class="campaign-wrap">
      <div class="campaign-kv">
        <img src="@/assets/images/campaign/3rd_anniversary/3th_KV.jpg" />
      </div>
      <div class="campaign-kv-title">
        <img src="@/assets/images/campaign/3rd_anniversary/3th_title.png" />
      </div>
      <div class="bg-campaign-wrap">
        <div class="campaign-step">
          <img src="@/assets/images/campaign/3rd_anniversary/step01.png">
          <img src="@/assets/images/campaign/3rd_anniversary/step02.png">
          <img src="@/assets/images/campaign/3rd_anniversary/step03.png">
        </div>
        <div class="store-button">
          <a class="store-button-apple" href="https://app.adjust.com/11kxtk16?redirect=https%3A%2F%2Fapps.apple.com%2Fjp%2Fapp%2F%25E6%2597%25A5%25E5%2590%2591%25E5%259D%258246%25E5%2585%25AC%25E5%25BC%258F-%25E3%2581%25B2%25E3%2581%25AA%25E3%2581%2593%25E3%2581%2584%2Fid1489909693" target="_blank">
            <img src="@/assets/images/campaign/pc_btn_apple_dl.png">
          </a>
          <a class="store-button-google" href="https://app.adjust.com/11c0cmdc?redirect=https%3A%2F%2Fplay.google.com%2Fstore%2Fapps%2Fdetails%3Fid%3Djp.co.tenantz.hinakoi" target="_blank">
            <img src="@/assets/images/campaign/pc_btn_google_dl.png">
          </a>
        </div>
        <div class="movie-wrap">
          <div class="movie-block">
            <iframe class="movie-block-iframe" src="https://www.youtube.com/embed/cjuJbcauCnw" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import resolution from '@/mixin/resolution';
export default {
  name: 'CampaignPage',
  components: {
    Header,
    Footer
  },
  mixins: [resolution]
}
</script>

<style lang="scss" scoped>
.campaign-wrap {
  .movie-wrap {
    .movie-block-iframe {
      width : 745px;
      aspect-ratio: 1/0.5625;
      height: auto;
      box-sizing: border-box;
    }
  }
}
.campaign-kv {
  width: 100%;
  img {
    width: 100%;
  }
}
.campaign-kv-title {
  width: 65%;
  max-width:937px;
  margin: 0 auto;
  margin-bottom: 20px;
  img {
    width: 100%;
  }
}
.bg-campaign-wrap {
  background-image: url("@/assets/images/campaign/3rd_anniversary/3th_bg.jpg");
  background-repeat: no-repeat;
  background-size: contain;
  padding-top: 20px;
}
.campaign-step {
  width: 88%;
  max-width: 1270px;
  margin: 0 auto;
  img {
    width: 100%;
  }
}
.store-button {
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  margin: 100px 0 30px;
  .store-button-apple {
    display: block;
    height: 96px;
    width: auto;
    margin-right: 80px;
  }
  .store-button-google {
    display: block;
    height: 96px;
    width: auto;
  }
  img {
    height: 100%;
    width: auto;
  }
}
.movie-wrap {
  text-align: center;
  .movie-block-text {
    position: relative;
    width: 560px;
    margin: 10px auto;
    left: -16px;
    text-align: left;
    color: #5ba7f2;
    font-family: 'Hiragino';
  }
  .movie-block-iframe {
    border: 1px solid #5bdac5;
    padding: 7px;
    width : 560px;
    height : 315px;
  }
}

@media screen and ( max-width:1023px) {
  .campaign-wrap {
    .movie-wrap {
      .movie-block-iframe {
        max-width: 100%;
        width: 100%;
        aspect-ratio: 1/0.5625;
        height: auto;
      }
    }
  }
  .conan-campaign-kv {
    width: 100%;
    img {
      width: 100%;
    }
  }
  .campaign-kv-title {
    width: 80%;
    max-width:80%;
    margin: 0 auto;
    margin-bottom: 10px;
    img {
      width: 100%;
    }
  }
  .bg-campaign-wrap {
    padding-top: 10px;
  }
  .campaign-step {
    width: 100%;
    max-width: 100%;
    margin: 0 auto;
    img {
      width: 100%;
    }
  }
  .store-button {
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;
    margin: 40px 0 20px;
    .store-button-apple {
      display: block;
      height: 35px;
      width: auto;
      margin-right: 40px;
    }
    .store-button-google {
      display: block;
      height: 35px;
      width: auto;
    }
    img {
      height: 100%;
      width: auto;
    }
  }
  .movie-wrap {
    .movie-block-text {
      width: 300px;
      left: -18px;
    }
    .movie-block-iframe {
      width : 300px;
      height : 180px;
    }
  }
}
</style>
